import type { LightEntity } from '@design/widgets/asset-logo/AssetLogo';
import clsx from 'clsx';

import sharedStyles from '../../AssetLogo.module.scss';
import { FixedIncomeLogo } from '../fixed-income-logo/FixedIncomeLogo';

export interface LogoImageProps {
  entity: LightEntity;
  className?: string;
  logoUrl: string;
  onError: () => void;
  size: number;
  isFiEntity: boolean;
}

export const LogoImage = ({
  entity,
  className,
  logoUrl,
  onError,
  size,
  isFiEntity,
}: LogoImageProps) => {
  const imgProps = {
    src: logoUrl,
    alt: 'logo-image',
    ['data-testid']: 'logo',
    onError,
  };

  return (
    <div
      className={clsx(sharedStyles.logoWrapper, className)}
      style={{ width: size, height: size }}
    >
      {isFiEntity ? (
        <FixedIncomeLogo
          imgProps={{ ...imgProps, ['data-testid']: 'fi-logo' }}
          entityTag={entity.tag}
        />
      ) : (
        <img {...imgProps} />
      )}
    </div>
  );
};
